import React from "react";

const TickIcon = ({ className }: { className: string }) => {
  return (
    <svg
      className={className}
      viewBox="0 0 31 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="15.1757" cy="14.9152" r="14.8398" fill="#E4EEF6" />
      <circle cx="15.1765" cy="14.9154" r="11.8719" fill="#0A3D5B" />
      <path
        d="M9.38281 15.5928L13.9614 19.2712L20.413 10.4002"
        stroke="#F8F9FA"
        strokeWidth="1.48398"
        strokeLinecap="round"
      />
    </svg>
  );
};

export default TickIcon;
